import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        tags: '=',
        resource: '='
    },
    template: `
    <span ng-if="!vm.canManageForm" class="text">{{ vm.tags.join(', ') }}</span>
    <script type="text/ng-template" id="customPopupTemplate.html">
        <div class="autocomplete"
             style="display: block;"
             ng-show="isOpen() && !moveInProgress"
             aria-hidden="{{!isOpen()}}">
            <ul role="listbox">
                <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }"
                    ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option" id="{{::match.id}}">
                    <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>
                </li>
            </ul>
        </div>
    </script>
    <div ng-if="vm.canManageForm" class="tags">
        <div class="values">
            <div ng-repeat="(idx, tag) in vm.tags" class="tag">{{tag}} <a ng-if="vm.canManageForm" class="close" href ng-click="vm.remove(idx)">×</a></div>
        </div>
        <div class="input">
            <input
             ng-keypress="vm.keyPress($event)"
             ng-disabled="!vm.canManageForm"
             type="text"
             ng-model="vm.selected"
             uib-typeahead="value.tag for value in vm.loadAutocomplete($viewValue) | limitTo:8"
             typeahead-popup-template-url="customPopupTemplate.html"
             typeahead-on-select="vm.selectTag($item, $model, $label)"
             class="form-control"
             ng-class="{'hidden': !vm.canManageForm}"
             >
        </div>
    </div>
    `
})
export default class {
    constructor (lodash, FormService, $timeout, $q) {
        this.lodash = lodash;
        this.FormService = FormService;
        this.$timeout = $timeout;
        this.$q = $q;
        this.debounceTimer = null;
        this.debounceDelay = 500;
    }

    $onInit () {
        this.canManageForm = this.FormService.canManageForm(this.form.model);
        this.form.model.tagsForm = this.form.model.tagsForm || [];
    }

    $onDestroy () {
        if (!this.debounceTimer) {
            return;
        }
        this.$timeout.cancel(this.debounceTimer);
    }

    keyPress (event) {
        if (event.keyCode === 13) {
            this.newValue = this.selected;
            this.selected = null;
            if (this.newValue && this.newValue.trim()) {
                this.add();
            }
        }
    }

    selectTag ($item, $model, $label) {
        this.newValue = $label;
        this.add();
        this.selected = null;
    }

    add () {
        if (!this.newValue || !this.newValue.trim()) {
            this.newValue = '';
            return;
        }
        if (this.tags.indexOf(this.newValue) === -1) {
            this.tags.push(this.newValue);
            this.form.model.tagsForm.push({ tag: this.newValue });
        }
        this.newValue = '';
    }

    remove (idx) {
        this.tags.splice(idx, 1);
        this.form.model.tagsForm.splice(idx, 1);
    }

    loadAutocomplete (keyword) {
        if (this.debounceTimer) {
            this.$timeout.cancel(this.debounceTimer);
        }

        if (!this.selected || keyword.length < 3) {
            return [];
        }

        const deferred = this.$q.defer();

        this.debounceTimer = this.$timeout(() => {
            this.resource.query({ query: keyword, pageSize: 0 }).$promise
                .then((response) => {
                    deferred.resolve(response);
                })
                .catch((error) => {
                    deferred.reject(error);
                });
        }, this.debounceDelay);

        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/tag/manager/index.js